import { render, staticRenderFns } from "./StatementVersions.vue?vue&type=template&id=27479653"
import script from "./StatementVersions.vue?vue&type=script&lang=js"
export * from "./StatementVersions.vue?vue&type=script&lang=js"
import style0 from "./StatementVersions.vue?vue&type=style&index=0&id=27479653&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports